// 清除存储桶中的文件碎片

import _ from 'lodash';
import cos from '@/scripts/helper/cos';

const mod = {
  ParallelLimit: 3,
  Queue: [],
  CurrIndex: 0,
  RunningCount: 0,
  SuccCount: 0,
  ErrCount: 0,

  run(options, succCb = () => {}, errCb, finalCb = () => {}) {
    mod.Queue = [];
    mod.RunningCount = 0;
    mod.CurrIndex = 0;
    mod.SuccCount = 0;
    mod.ErrCount = 0;

    mod.runQueue(options, succCb, errCb, finalCb);
  },

  runQueue(options, succCb, errCb, finalCb) {
    // reset
    mod.CurrIndex = 0;

    cos.multipartList(options, (err, data) => {
      if (err) {
        errCb(err.error || err);
        return;
      }

      const { Upload } = data;
      if (!Upload || !Upload.length) {
        finalCb();
        return;
      }

      mod.Queue = Upload.map(item => {
        item.hasDeleted = false;
        item.isDeleting = false;
        return item;
      });

      mod.runDelete(options, succCb, errCb, () => {
        if (data.IsTruncated === 'true') {
          mod.runQueue(options, succCb, errCb, finalCb);
        } else {
          finalCb(mod.SuccCount, mod.ErrCount);
        }
      });
    });
  },

  runDelete(options, succCb, errCb, cb) {
    const { CurrIndex } = mod;

    if (mod.RunningCount >= mod.ParallelLimit) {
      mod.CurrIndex--;
      return;
    }

    if (!mod.Queue[CurrIndex]) {
      return;
    }

    mod.Queue[CurrIndex].isDeleting = true;
    cos.multipartAbort(
      {
        Bucket: options.Bucket,
        Region: options.Region,
        Key: mod.Queue[CurrIndex].Key,
        UploadId: mod.Queue[CurrIndex].UploadId,
      },
      (err, data) => {
        if (err) {
          mod.ErrCount++;
          mod.RunningCount--;
          mod.Queue[CurrIndex].isDeleting = false;
          errCb(err.error || err, mod.ErrCount, mod.Queue[CurrIndex]);
          return;
        }

        mod.Queue[CurrIndex].isDeleting = false;
        mod.Queue[CurrIndex].hasDeleted = true;
        mod.RunningCount--;
        mod.CurrIndex++;

        mod.SuccCount++;
        succCb(data, mod.SuccCount, mod.Queue[CurrIndex]);

        const undo = mod.Queue.filter(item => item.hasDeleted === false && item.isDeleting === false);
        const undoIndex = _.findIndex(mod.Queue, { hasDeleted: false, isDeleting: false });
        const runningItem = mod.Queue.filter(item => item.hasDeleted === false && item.isDeleting === true);

        if (undo.length) {
          if (undoIndex < CurrIndex) {
            mod.CurrIndex = undoIndex;
          }

          mod.runDelete(options, succCb, errCb, cb);
        } else if (!runningItem.length) {
          cb();
        }
      },
    );

    mod.RunningCount++;
    mod.CurrIndex++;
    mod.runDelete(options, succCb, errCb, cb);
  },

  isRunning() {
    return mod.RunningCount !== 0;
  },
};

export default mod;
